import React from "react";
import { IconProps } from "..";

export default (props: IconProps) => (
    <svg {...props} viewBox="0 0 11 12" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M5.988 10 1 4.98c.176-.323.464-.685.863-1.087a7.18 7.18 0 0 1 .528-.483c.176-.144.312-.241.408-.29l.143-.096L5.988 6.09 9.058 3c.335.193.695.483 1.079.869.176.177.335.354.48.531l.215.275c.039.052.07.097.096.135l.072.145L5.988 10z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);
